import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import ProporsalNotification from '@/models/porposal/proposalNotification.Model';
export default class ProposalNotificationService {
  client: BaseHttpClient;
  constructor(public controller: string = "ProposalNotification") {
    this.client = new BaseHttpClient(controller);
  }
  async LastNotifications(userId:number):Promise<ProporsalNotification[]>{
    return await this.client.getAsync('LastNotifications', { userId:userId});
  }
  async MarkAsRead(model: ProporsalNotification): Promise<ProporsalNotification> {
    return await this.client.putAsync('MarkAsRead', model.id, model);
  }
  async ViewAllNotifications(userId:number):Promise<ProporsalNotification[]>{
    return await this.client.getAsync('ViewAllNotifications', { userId:userId});
  }
    async GetNotificactionNumber(userId:number):Promise<ProporsalNotification[]>{
      return await this.client.getAsync('GetNotificactionNumber', { userId:userId});
    }
 }